/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListProductsRequest
 */
export interface ListProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof ListProductsRequest
     */
    cursor?: number;
    /**
     * 
     * @type {number}
     * @memberof ListProductsRequest
     */
    limit?: number;
}

export function ListProductsRequestFromJSON(json: any): ListProductsRequest {
    return ListProductsRequestFromJSONTyped(json, false);
}

export function ListProductsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListProductsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function ListProductsRequestToJSON(value?: ListProductsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cursor': value.cursor,
        'limit': value.limit,
    };
}


